import { Table, TableBody, TableCell, TableHead, TableRow, TableHeader } from "core/components/v2/Table"
import ProgressMeetViewModel from "../ProgressMeetViewModel"
import AttendanceFailureModal from "presentation/Student/Course/components/AttendanceFailureModal"
import React from "react"
import { Tooltip } from "@mui/material"
interface Session {
  chapter_name: string
  session_timestamp: number
  class_link: string
  meeting_id: any
}
interface UpcomingSessionTableProps {
  upcomingSessions: Session[]
  captureAttendance: any
  progressMeetLink: any
}

const UpcomingSessionTable: React.FC<UpcomingSessionTableProps> = ({
  upcomingSessions,
  captureAttendance,
  progressMeetLink,
}) => {
  const [currentTime, setCurrentTime] = React.useState(Math.floor(Date.now() / 1000))
  const [selectedSession, setSelectedSession] = React.useState<Session>()

  const formatTimestamp = (timestamp: number) => {
    const date = new Date(timestamp * 1000)

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })

    return `${formattedDate} | ${formattedTime}`
  }
  const {
    handleJoinNow,
    waitingTime,
    attendanceFailure,
    setAttendanceFailure,
    attendanceFailureCount,
    currentClassLink,
    setWaitingTime,
  } = ProgressMeetViewModel()
  React.useEffect(() => {
    localStorage.setItem("attendanceFailureCount", attendanceFailureCount.toString())

    if (attendanceFailureCount >= 3) {
      window.open(currentClassLink)
      setAttendanceFailure(false)
    }
  }, [attendanceFailureCount])
  React.useEffect(() => {
    if (waitingTime > 0) {
      const timer = setInterval(() => {
        setWaitingTime((prevTime) => prevTime - 1)
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [waitingTime])

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000))
    }, 1000)

    return () => clearInterval(interval)
  }, [])
  const sortedUpcomingSessions = [...(upcomingSessions || [])].sort((a, b) => a.session_timestamp - b.session_timestamp)

  return (
    <>
      <Table className="overflow-hidden rounded w-full  mt-6">
        <TableHeader className="rounded  h-[31px]">
          <TableRow className="rounded bg-[#333] px-4">
            <TableHead className="text-xs text-white px-4">Progress Meet</TableHead>
            <TableHead className="text-xs text-white px-1">Date & Time</TableHead>
            <TableHead className="text-xs text-white px-1"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedUpcomingSessions.length > 0 ? (
            sortedUpcomingSessions.map((session, index) => (
              <TableRow key={index} className="px-4 hover:bg-[#ebebeb] h-[31px]">
                <TableCell className="text-xs px-4 py-2 text-left">{session.chapter_name}</TableCell>
                <TableCell className="text-xs px-1 py-2 text-left">
                  {formatTimestamp(session.session_timestamp)}
                </TableCell>
                <TableCell className="text-xs px-1 py-2 text-right">
                  <Tooltip
                    title={
                      session.session_timestamp - currentTime > 1800
                        ? "Link will be active half an hour before it starts"
                        : "Join now"
                    }
                  >
                    <div>
                      <button
                        className="flex cursor-pointer items-center justify-center rounded-[4px] bg-white py-[5px] px-4 text-[12px] font-medium leading-[15px] text-[#646464] hover:bg-[#EBEBEB] border-[0.5px] border-[#d3d3d3] h-[25px]"
                        onClick={() => {
                          setSelectedSession(session)
                          handleJoinNow(session)
                        }}
                        disabled={session.session_timestamp - currentTime > 1800}
                      >
                        Join Link
                      </button>
                      <AttendanceFailureModal
                        waitingTime={waitingTime}
                        isOpen={attendanceFailure}
                        onClose={() => setAttendanceFailure(false)}
                        handleNewSubmitFeedback={() => handleJoinNow(selectedSession)}
                      />
                    </div>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow className="px-4 hover:bg-[#ebebeb]">
              <TableCell colSpan={3} className="text-center py-4 text-gray-500">
                No data available
              </TableCell>
            </TableRow>
          )}
          <tr className="bg-[#F9F9F9]">
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
          </tr>
        </TableBody>
      </Table>
    </>
  )
}
export default UpcomingSessionTable
